import gql from "graphql-tag";

export const ME_FOR_REVIEW = gql`
  query meForReview($first: Int, $after: String) {
    me {
      reviews (first: $first, after: $after){
        totalCount
        pageInfo {
          startCursor
        }
        edges {
          node {
            id
            title
            comment
            rating
            status
            hasImage
            images {
              id
              url(size: 540)
            }
            product {
              id
              name
              brand
            }
          }
        }
      }
    }
  }
`;